import React, { useMemo } from 'react';
import { StyleSheet, Image, View, Platform, ScrollView, Text, TouchableOpacity } from 'react-native';
import type { ImageStyle } from 'react-native';
import FadeIn from 'react-native-fade-in-image';
import Card from 'src/presentation/components/atoms/Card';
import Heading from 'src/presentation/components/atoms/Heading';
import Paragraph from 'src/presentation/components/atoms/Paragraph';
import NavBar from 'src/presentation/components/organisms/NavBar';
import { useServicesStore } from 'src/domain/stores/useServicesStore';
import { useContentWidth } from 'src/presentation/hooks/useContentWidth';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Translations from 'src/core/utils/Translations';
import Icons from 'src/core/utils/Icons';
import Images from 'src/core/utils/Images';

function ContactScreen() {
	const { openPhoneNumber, openUrlInternally } = useServicesStore();
	const contentWidth = useContentWidth();

	const sizedStyles = useMemo((): { img: ImageStyle } => ({ img: { width: contentWidth } }), [contentWidth]);

	return (
		<View style={styles.root}>
			<NavBar
				backBtn={true}
				bgcolor={Colors.primary}
				centerTitle={true}
				color={Colors.black}
				editBtn={false}
				title={Translations.titleContact}
			/>
			<ScrollView style={Platform.OS === 'android' ? styles.scrollAndroid : undefined}>
				<FadeIn>
					<Image resizeMode="cover" source={Images.contactHeader} style={[styles.img, sizedStyles.img]} />
				</FadeIn>
				<Card>
					<View style={styles.contentContainer}>
						<Heading text={Translations.titleContact} />
						<Paragraph text={Translations.textContactTopicus} />
						<Paragraph text={Translations.textContactAddress} />
						<Paragraph text={Translations.textContactPostal} />
					</View>
					<View style={styles.linksContainer}>
						<TouchableOpacity
							style={styles.linkRow}
							onPress={() => openPhoneNumber({ phoneNumber: '0570662662' }).catch(() => undefined)}
						>
							<Image resizeMode="cover" source={Icons.contactPhone} style={styles.listItemIcon} />
							<View>
								<Text style={StyleSheet.flatten(styles.listItemText)}>0570 662 662</Text>
							</View>
						</TouchableOpacity>
						<TouchableOpacity
							style={styles.linkRow}
							onPress={() => openUrlInternally({ url: 'https://www.topicus.nl' }).catch(() => undefined)}
						>
							<Image resizeMode="cover" source={Icons.contactWeb} style={styles.listItemIcon} />
							<View>
								<Text style={StyleSheet.flatten(styles.listItemText)}>www.topicus.nl</Text>
							</View>
						</TouchableOpacity>
					</View>
					{Platform.OS === 'ios' ? <View style={styles.iosSpacer} /> : null}
				</Card>
			</ScrollView>
		</View>
	);
}

export default ContactScreen;

const styles = StyleSheet.create({
	root: {
		flex: 1,
	},
	scrollAndroid: {
		backgroundColor: Colors.white,
	},
	contentContainer: {
		paddingLeft: Dimens.padding20,
		paddingTop: Dimens.padding20,
		marginBottom: Dimens.margin15,
	},
	linksContainer: {
		paddingHorizontal: Dimens.padding20,
		gap: Dimens.margin16,
	},
	linkRow: {
		flexDirection: 'row',
		gap: Dimens.margin16,
		alignItems: 'center',
	},
	iosSpacer: {
		height: Dimens.padding40,
		flex: 1,
	},
	img: {
		height: 210,
	},
	listItemIcon: {
		width: 25,
		height: 25,
	},
	listItemText: {
		color: Colors.secondary,
	},
});
